import * as React from 'react'
const styles = require('./styles')

interface OfferLoadingIndicatorProps {
  loading: boolean
  noOffersFound: boolean
}
export const OfferLoadingIndicator: React.FC<OfferLoadingIndicatorProps> = ({
  loading,
  noOffersFound,
}: OfferLoadingIndicatorProps) => (
  <div className={styles.loadingWrapper}>
    <div className={styles.liOfferCard}>
      <div className={styles.largePlaceholder}></div>
      <div className={styles.mediumPlaceholder}></div>
      <div className={styles.smallPlaceholder}></div>
      <div className={styles.smallPlaceholder}></div>
      <div className={styles.bottomPlaceholder}></div>
    </div>
    <div className={styles.loadingMessage}>
      {loading && <h4 data-testid="li-loading-msg">Finding an offer tailored to you.</h4>}
      {noOffersFound && (
        <h4 data-testid="li-error-msg">
          Please call <span className={styles.errorPhoneNumber}>844-755-5327</span> to get you started on finding the
          best life insurance rates for your needs.
        </h4>
      )}
      {loading && <div className={styles.loaderIcon} data-testid="li-loading-spinner"></div>}
    </div>
  </div>
)
